import {lazy} from 'react';

export const CreReferencesMapLazy = lazy(() => import(/* webpackChunkName: "creReferencesMap" */ '.'));
